/**
 * @generated SignedSource<<86a4d3af1878eaa424146908b993757d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ControlledAddressForm_viewer$data = {
  readonly geography: {
    readonly countries: ReadonlyArray<{
      readonly abbreviation: string | null;
      readonly name: string | null;
    } | null> | null;
    readonly usStates: ReadonlyArray<{
      readonly abbreviation: string | null;
      readonly name: string | null;
    } | null> | null;
  } | null;
  readonly zipCodeLookUp?: ReadonlyArray<{
    readonly city: string | null;
    readonly state: string | null;
  } | null> | null;
  readonly " $fragmentType": "ControlledAddressForm_viewer";
};
export type ControlledAddressForm_viewer$key = {
  readonly " $data"?: ControlledAddressForm_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ControlledAddressForm_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "abbreviation",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "canCheckZipCode"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "country"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "zipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ControlledAddressForm_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Geography",
      "kind": "LinkedField",
      "name": "geography",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GeographyObject",
          "kind": "LinkedField",
          "name": "countries",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GeographyObject",
          "kind": "LinkedField",
          "name": "usStates",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "canCheckZipCode",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "zipCodeLookUp",
          "args": [
            {
              "kind": "Variable",
              "name": "country",
              "variableName": "country"
            },
            {
              "kind": "Variable",
              "name": "zipCode",
              "variableName": "zipCode"
            }
          ],
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "zipCode",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "city",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "state",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "89eae6914c0775f0706c14eb8f04fd03";

export default node;
